import { Component, Host, Prop, h, Element } from '@stencil/core';
/**
 * @slot payment - Replaces payment item, has replaceable props `{image}`, `{payment}`.
 * @slot sbc - Replaces SBC certificate item, has replaceable props `{image}`.
 * @slot cod - Replaces COD item, has replaceable props `{image}`.
 */
@Component({
  tag: 'salla-payments',
  styleUrl: 'salla-payments.scss'
})

export class SallaPayments {
  @Element() host: HTMLElement;
  private paymentSlot: string;
  private sbcSlot: string;
  private codSlot: string;
  private payments: string[];
  private placeholderImage: string;
  /**
   * Array of the payments/items that are not supported, ex: ["sbc", "made-in-ksa", "cod", "mada", ""].
   */
  @Prop({ mutable: true }) exclude: string[] = [];

  componentWillLoad() {
    return salla.onReady()
      .then(() => {
        if (typeof this.exclude === 'string') {
          try {
            this.exclude = JSON.parse(this.exclude);
          } catch (error) {
            salla.logger.error('salla-payments:: failed to parse the exclude props!', this.exclude);
            this.exclude = [];
          }
        }
        this.placeholderImage = salla.url.cdn(`images/s-empty.png`);
        this.paymentSlot = this.host.querySelector('[slot="payment"]')?.innerHTML || `<li class="s-payments-list-item"><img class="lazy" width="100%" height="100%" src="${this.placeholderImage}" data-src="{image}" alt={payment} /><li>`;
        this.sbcSlot = this.host.querySelector('[slot="sbc"]')?.innerHTML || `<li class="s-payments-list-item"><a target="_blank" href="{link}"> <img width="100%" height="100%" src="${this.placeholderImage}" data-src={image} class="lazy s-payments-sbc-image" alt="SBC"/></a><li>`;
        this.codSlot = this.host.querySelector('[slot="cod"]')?.innerHTML || `<li class="s-payments-list-item"> <img width="100%" height="100%" src="${this.placeholderImage}" data-src={image} class="lazy" alt="COD"/><li>`;
        this.payments = salla.config.get('store.settings.payments');
      })
  }
  
  render() {
    const madeInKSA = !this.exclude.includes('made-in-ksa') && salla.config.get('store.settings.made_in_ksa');
    const sbcId = this.exclude.includes('sbc') ? null : salla.config.get('store.settings.certificate.id');
    return (
      <Host class="s-payments-list-wrap">
        { }
        <ul class="s-payments-list">
          {madeInKSA && <li class="s-payments-list-item">
            <img class="lazy" width="100%" height="100%" decoding="async" loading="lazy" data-src={salla.url.cdn(`images/made-in-ksa.svg`, 58, 58)} alt="made in KSA certified" />
          </li>}

          {/* Dynamic methods */}
          {this.payments.map((payment) => (
            payment == "cod" ?
              <div id="cod-slot" innerHTML={this.codSlot
                .replace(/\{image\}/g, salla.url.cdn(`images/payment/cod_mini.png`, 58, 58))}>
              </div> :
              <div id="payment-slot" innerHTML={this.paymentSlot
                .replace(/\{image\}/g, salla.url.cdn(`images/payment/${payment}_mini.png`, 58, 58))
                .replace(/\{payment\}/g, payment)}>
              </div>
          ))}

          {/* SBC certificate */}
          {sbcId && <div id="sbc-slot" innerHTML={this.sbcSlot
            .replace(/\{image\}/g, salla.url.cdn(`images/sbc.png`, 58, 58))
            .replace(/\{link\}/g, `https://eauthenticate.saudibusiness.gov.sa/certificate-details/${sbcId}`)}>
          </div>}
        </ul>
      </Host>
    );
  }
  componentDidLoad() {
    //todo:: double check about the following workaround, it looks not normal
    document.lazyLoadInstance?.update(this.host.querySelectorAll('.lazy'));
    // fix lazy loaded images that have 100% width and height
    this.host.querySelectorAll('.lazy').forEach((img) => {
      img.addEventListener('load', () => {
        img.setAttribute('width', "100%");
        img.setAttribute('height', "100%");
      });
    });
  }
  componentDidRender() {
    //todo:: double check about the following workaround to reduce the dom length, it looks unusal
    this.host.querySelectorAll('#payment-slot').forEach(el => el.replaceWith(el.firstChild));
    this.host.querySelectorAll('#sbc-slot').forEach(el => el.replaceWith(el.firstChild));
    this.host.querySelectorAll('#cod-slot').forEach(el => el.replaceWith(el.firstChild));
    this.host.querySelector('[slot="payment"]')?.remove();
    this.host.querySelector('[slot="sbc"]')?.remove();
    this.host.querySelector('[slot="cod"]')?.remove();
  }
}
